import mitt from 'mitt';
import { module } from 'stereomodularjs';
import { createApp } from "vue/dist/vue.esm-bundler.js"
import formcomponent from '../components/flexibleForm/Form.vue'
import RichText from '../components/flexibleForm/RichText.vue';
import message from '../components/flexibleForm/RichText.vue';
import FormFieldsGroup from '../components/flexibleForm/FormFieldsGroup.vue';
import FormStepper from '../components/flexibleForm/FormStepper.vue';
import FormRecoverModal from '../components/flexibleForm/FormRecoverModal.vue';
import FormSection from '../components/flexibleForm/FormSection.vue'
import text from '../components/flexibleForm/Input-text.vue';
import inputlabel from '../components/flexibleForm/Input-label.vue';
import textarea from '../components/flexibleForm/Input-textarea.vue';
import checkbox from '../components/flexibleForm/Input-checkbox.vue';
import imagecheckbox from '../components/flexibleForm/Input-imagecheckbox.vue';
import radio from '../components/flexibleForm/Input-radio.vue';
import select from '../components/flexibleForm/Input-select.vue';
// import vindecode from '../components/flexibleForm/Input-vindecode.vue';
// import nhtsamodelselector from '../components/flexibleForm/Input-nhtsamodelselector.vue';
// import nhtsamakeselector from '../components/flexibleForm/Input-nhtsamakeselector.vue';
// import nhtsayearselector from '../components/flexibleForm/Input-nhtsayearselector.vue';
// import businesstypescategories from '../components/flexibleForm/Input-businesstypescategories.vue';
// import businesstypes from '../components/flexibleForm/Input-businesstypes.vue';
import addressbycanadapost from '../components/flexibleForm/Input-addressbycanadapost.vue';
import fileInput from '../components/flexibleForm/Input-file.vue';
import svgIco from '../components/flexibleForm/svg-Ico.vue';


export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        
        let self = this;
        const app = createApp({
            components: {
                formcomponent,
            },
            data() {
                return {
                    loading: true,
                    spriteURL: null,
                    session: null,
                    sessionTO: null,
                    translationsString: {},
                    currentlanguage: 'fr-CA',
                    canadaPost_APIKey: '',
                    form: {}
                }
            },
            mounted() {
                this.loading = false
            },
            methods: {
                
                translateString: function (text) {
                    let translationsString = this.$root.translationsString
                    let lang = this.$root.currentlanguage

                    if (!translationsString[text]) translationsString[text] = {}
                    if(!translationsString[text][lang]) translationsString[text][lang] = text
                    return translationsString[text][lang]
                },

                getSessionInfo: function () {
                    
                    if(this.session) return this.session

                    return fetch('/actions/users/session-info', {
                        headers: {
                            'Accept': 'application/json',
                        },
                    })
                    .then(response => response.json())
                    .then(session => {
                        this.session = session
                        
                        clearTimeout(this.sessionTO)
                        this.sessionTO = setTimeout(() => {
                            this.session = null
                        }, 180000)
                        
                        return session
                    })

                },

                nl2br(str, is_xhtml) {
                    if (typeof str === 'undefined' || str === null) {
                        return '';
                    }
                    var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
                    return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
                }

            }
        })
        app.component("FormSection", FormSection)
        app.component("FormFieldsGroup", FormFieldsGroup)
        app.component("FormStepper", FormStepper)
        app.component("FormRecoverModal", FormRecoverModal)
        app.component("RichText", RichText)
        app.component("inputlabel", inputlabel)
        app.component("text", text)
        app.component("email", text)
        app.component("phone", text)
        app.component("date", text)
        app.component("month", text)
        app.component("hidden", text)
        app.component("number", text)
        app.component("textarea", textarea)
        app.component("message", message)
        // app.component("vindecode", vindecode)
        // app.component("nhtsamakeselector", nhtsamakeselector)
        // app.component("nhtsamodelselector", nhtsamodelselector)
        // app.component("nhtsayearselector", nhtsayearselector)
        // app.component("businesstypes", businesstypes)
        // app.component("businesstypescategories", businesstypescategories)
        app.component("addressbycanadapost", addressbycanadapost)
        app.component("checkbox", checkbox)
        app.component("imagecheckbox", imagecheckbox)
        app.component("inlinecheckbox", checkbox)
        app.component("radio", radio)
        app.component("switch", radio)
        app.component("select", select)
        app.component("file", fileInput)
        app.component("svgIco", svgIco)

        app.config.globalProperties.emitter = mitt()
        app.config.globalProperties._t = app._component.methods.translateString

        app.mount(self.el)
    }
}
